
import React, { useLayoutEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function TermsPage() {
  const navigate = useNavigate();
  const pageTopRef = useRef(null);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    if (pageTopRef.current) {
      pageTopRef.current.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
    }
  }, []);

  const handleBack = () => {
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }

    navigate(-1);
  };

  return (
    <div ref={pageTopRef} className="terms-page">
      <style>{`
        .terms-page {
          min-height: 100vh;
          background: #f7faf8;
          color: #111827;
          font-family: Inter, "Avenir Next", Arial, sans-serif;
          line-height: 1.65;
        }

        .terms-shell {
          max-width: 960px;
          margin: 0 auto;
          padding: 34px 24px 72px;
        }

        .terms-back {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 26px;
          color: #148a58;
          font-size: 14px;
          font-weight: 650;
          text-decoration: none;
        }

        .terms-back:hover {
          text-decoration: underline;
        }

        .terms-back-button {
          border: none;
          background: transparent;
          padding: 0;
          cursor: pointer;
          font-family: inherit;
        }

        .terms-hero {
          padding: 46px 44px;
          margin-bottom: 26px;
          border-radius: 28px;
          color: #ffffff;
          background: linear-gradient(135deg, #0c6943 0%, #148a58 100%);
          box-shadow: 0 18px 48px rgba(20, 138, 88, 0.16);
        }

        .terms-hero-label {
          display: inline-flex;
          padding: 6px 13px;
          margin-bottom: 18px;
          border: 1px solid rgba(255, 255, 255, 0.25);
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.13);
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.09em;
          text-transform: uppercase;
        }

        .terms-hero h1 {
          margin: 0 0 13px;
          font-size: clamp(34px, 5vw, 47px);
          font-weight: 760;
          line-height: 1.1;
          letter-spacing: -0.045em;
        }

        .terms-hero-description {
          max-width: 720px;
          margin: 0;
          color: rgba(255, 255, 255, 0.9);
          font-size: 16px;
        }

        .terms-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 11px;
          margin-top: 30px;
        }

        .terms-meta-item {
          padding: 9px 13px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.11);
          color: rgba(255, 255, 255, 0.94);
          font-size: 13px;
        }

        .terms-card {
          padding: 30px 32px;
          margin-bottom: 17px;
          border: 1px solid #e3ebe6;
          border-radius: 22px;
          background: #ffffff;
          box-shadow: 0 5px 22px rgba(17, 24, 39, 0.035);
        }
          .terms-business-notice {
  margin: 0 0 13px;
  color: #374151;
  font-size: 15px;
  line-height: 1.65;
  font-weight: 400;
}

        .terms-card h2 {
          display: flex;
          align-items: center;
          gap: 12px;
          margin: 0 0 16px;
          color: #111827;
          font-size: 21px;
          font-weight: 720;
          letter-spacing: -0.02em;
        }

        .terms-number {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 11px;
          background: #e9f6ef;
          color: #148a58;
          font-size: 14px;
          font-weight: 750;
        }

        .terms-card p {
          margin: 0 0 13px;
          color: #374151;
          font-size: 15px;
        }

        .terms-card p:last-child {
          margin-bottom: 0;
        }

        .terms-list {
          margin: 8px 0 0;
          padding-left: 21px;
          color: #374151;
          font-size: 15px;
        }

        .terms-list li {
          margin-bottom: 9px;
          padding-left: 3px;
        }

        .terms-list li:last-child {
          margin-bottom: 0;
        }

        .terms-highlight {
          padding: 18px 20px;
          margin-top: 18px;
          border-left: 4px solid #148a58;
          border-radius: 13px;
          background: #f1faf5;
          color: #244536;
          font-size: 14px;
        }

        .terms-warning {
          padding: 18px 20px;
          margin-top: 18px;
          border-left: 4px solid #d59b25;
          border-radius: 13px;
          background: #fffaf0;
          color: #594019;
          font-size: 14px;
        }

        .terms-link {
          color: #148a58;
          font-weight: 600;
          text-decoration: underline;
          text-underline-offset: 2px;
        }

        .terms-documents {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 12px;
          margin-top: 18px;
        }

        .terms-document-link {
          display: block;
          padding: 14px 15px;
          border: 1px solid #e3ebe6;
          border-radius: 13px;
          background: #f8fbf9;
          color: #148a58;
          font-size: 14px;
          font-weight: 650;
          text-decoration: none;
        }

        .terms-document-link:hover {
          border-color: #b8dcc8;
          background: #f1faf5;
        }

        .terms-approval {
          padding: 28px 32px;
          margin-top: 20px;
          margin-bottom: 17px;
          border-radius: 22px;
          border: 1px solid #d7eadf;
          background: #eff9f3;
        }

        .terms-approval h2 {
          margin: 0 0 12px;
          color: #10271e;
          font-size: 21px;
          font-weight: 720;
          letter-spacing: -0.02em;
        }

        .terms-approval p {
          margin: 0 0 12px;
          color: #374151;
          font-size: 15px;
        }

        .terms-approval p:last-child {
          margin-bottom: 0;
        }

        .terms-contact {
          padding: 30px 32px;
          margin-top: 20px;
          border-radius: 22px;
          background: #10271e;
          color: #ffffff;
        }

        .terms-contact h2 {
          margin: 0 0 10px;
          font-size: 21px;
          letter-spacing: -0.02em;
        }

        .terms-contact p {
          margin: 0 0 14px;
          color: rgba(255, 255, 255, 0.82);
          font-size: 15px;
        }

        .terms-contact a {
          color: #ffffff;
          font-weight: 650;
          text-decoration: underline;
          text-underline-offset: 3px;
        }

        .terms-footer {
          padding-top: 30px;
          color: #64748b;
          font-size: 13px;
          text-align: center;
        }

        @media (max-width: 640px) {
          .terms-shell {
            padding: 20px 15px 48px;
          }

          .terms-hero {
            padding: 32px 23px;
            border-radius: 21px;
          }

          .terms-card,
          .terms-approval,
          .terms-contact {
            padding: 23px 20px;
            border-radius: 18px;
          }

          .terms-card h2 {
            align-items: flex-start;
            font-size: 19px;
          }

          .terms-documents {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <main className="terms-shell">
        <button
          type="button"
          className="terms-back terms-back-button"
          onClick={handleBack}
        >
          ← Back to EcoTrack
        </button>

        <header className="terms-hero">
          <div className="terms-hero-label">Legal Information</div>

          <h1>Terms and Conditions</h1>

          <p className="terms-hero-description">
            These Terms govern access to and use of EcoTrack, a digital ESG
            self-assessment and support tool provided exclusively for business
            and professional users.
          </p>

          <div className="terms-meta">
            <div className="terms-meta-item">Last updated: 31 May 2026</div>
            <div className="terms-meta-item">Viridis by Serap Cevirgen</div>
            <div className="terms-meta-item">VAT No. 04191120130</div>
          </div>
        </header>

        <section className="terms-card">
          <h2>
            <span className="terms-number">1</span>
            Scope
          </h2>

          <p>
            <strong>1.1</strong> These Terms and Conditions govern access to
            and use of EcoTrack and its related features.
          </p>

          <p>
            <strong>1.2</strong> EcoTrack is operated by{" "}
            <strong>Viridis by Serap Cevirgen</strong>, VAT No. 04191120130,
            referred to in these Terms as the <strong>Provider</strong>.
          </p>

          <p>
            <strong>1.3</strong> EcoTrack is intended exclusively for business
            and professional users acting in connection with a trade, business
            or professional activity. It is not offered to private consumers
            acting outside such activity.
          </p>

          <div className="terms-business-notice">
  During checkout, users are required to confirm that they are
  purchasing and using EcoTrack for professional or business purposes
  and that they are authorised to act on behalf of the relevant
  business, organisation or professional activity.
</div>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">2</span>
            Nature of the service
          </h2>

          <p>
            <strong>2.1</strong> EcoTrack is a digital ESG support tool designed
            to help users complete ESG questionnaires, view indicative results,
            access summaries and graphs, receive tailored suggestions and,
            where available, download related outputs.
          </p>

          <p>
            <strong>2.2</strong> EcoTrack is an informational and
            decision-support tool only.
          </p>

          <p>
            <strong>2.3</strong> EcoTrack does not provide legal, regulatory,
            tax, accounting, audit, assurance, investment, certification or
            other professional advice.
          </p>

          <p>
            <strong>2.4</strong> EcoTrack does not guarantee compliance with
            CSRD, ESRS, EU Taxonomy requirements, ISO standards, EcoVadis
            requirements or any other legal, voluntary or commercial
            framework.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">3</span>
            Accounts and eligibility
          </h2>

          <p>
            <strong>3.1</strong> Users must act in a professional or business
            capacity and must provide accurate account and profile information.
          </p>

          <p>
            <strong>3.2</strong> During checkout, users confirm that they act
            as or for a business, organisation or professional activity and are
            authorised to purchase access where they act on behalf of another
            entity.
          </p>

          <p>
            <strong>3.3</strong> Users are responsible for maintaining the
            confidentiality of their login credentials and for activities
            carried out through their accounts.
          </p>

          <p>
            <strong>3.4</strong> Users must promptly notify the Provider if
            they become aware of unauthorised account access or suspected
            misuse of EcoTrack.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">4</span>
            Subscription, online contracting and payments
          </h2>

          <p>
            <strong>4.1</strong> Access to some or all EcoTrack features
            requires payment of a subscription fee.
          </p>

          <p>
            <strong>4.2</strong> Unless stated otherwise during checkout,
            EcoTrack operates on a yearly auto-renewing subscription model. The
            subscription renews automatically for successive yearly periods
            unless cancelled before the applicable renewal date.
          </p>

          <p>
            <strong>4.3</strong> The subscription price, billing period,
            renewal information and any applicable taxes are displayed before
            payment is submitted.
          </p>

          <p>
            <strong>4.4</strong> Payments are processed through Stripe or
            Stripe-supported payment methods. Payment-card details are handled
            through Stripe&apos;s payment environment and are not stored in
            full by EcoTrack. Stripe Customer Portal is used to allow
            customers to manage and cancel subscription renewal securely.
          </p>

          <p>
            <strong>4.5</strong> The technical steps for purchasing EcoTrack
            access are:
          </p>

          <ul className="terms-list">
            <li>the user creates or accesses an EcoTrack account;</li>
            <li>the user reviews the available annual plan and price;</li>
            <li>
              the user completes the required business-use and contractual
              acceptance checkboxes;
            </li>
            <li>
              the user selects the payment button and is redirected to the
              connected Stripe checkout flow;
            </li>
            <li>
              following successful payment confirmation, paid access is
              provisioned through EcoTrack.
            </li>
          </ul>

          <p style={{ marginTop: 16 }}>
            <strong>4.6</strong> Before submitting payment, users may review
            the plan information, decide whether to accept the relevant legal
            documents and refrain from proceeding if any information is
            incorrect or unacceptable.
          </p>

          <p>
            <strong>4.7</strong> These Terms are made available before payment
            and may be viewed, stored or reproduced by the user.
          </p>

          <p>
            <strong>4.8</strong> The subscription contract is concluded when
            payment is successfully confirmed through the connected checkout
            process. Paid EcoTrack access is then activated in accordance with
            the service workflow.
          </p>

          <p>
            <strong>4.9</strong> The contractual language currently available
            for EcoTrack checkout and these Terms is English.
          </p>

          <p>
            <strong>4.10</strong> As EcoTrack is provided exclusively in a
            business or professional context, the parties agree that the
            electronic payment and access confirmation presented through the
            connected checkout and EcoTrack flow constitutes confirmation of
            the online order and subscription activation.
          </p>

          <p>
            <strong>4.11</strong> Failure of payment, expiry of the selected
            payment method or payment reversal may result in suspension or
            limitation of paid access.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">5</span>
            Cancellation, account closure and refunds
          </h2>

          <p>
            <strong>5.1</strong> Customers may initiate cancellation of
            automatic renewal through the account-closure and
            subscription-cancellation function available in{" "}
            <strong>Profile &amp; Settings</strong>. Where an active paid
            subscription exists, selecting{" "}
            <strong>Close account and cancel subscription</strong> redirects
            the customer to <strong>Stripe Customer Portal</strong>, where the
            customer must securely complete the cancellation.
          </p>

          <p>
            <strong>5.2</strong> Unless otherwise shown in Stripe Customer
            Portal or required by mandatory law, cancellation takes effect at
            the end of the current paid subscription period. The customer
            retains access until that period ends and will not be charged for a
            subsequent annual renewal. Starting the cancellation flow without
            completing cancellation in Stripe does not cancel renewal.
          </p>

          <p>
            <strong>5.3</strong> Where the customer completes subscription
            cancellation using the EcoTrack account-closure flow, an
            account-deletion request is submitted to the Provider for manual
            processing. Subscription cancellation and account deletion remain
            distinct actions: deletion is not immediate and will be handled
            having regard to remaining paid access and any legally necessary
            retention of records.
          </p>

          <p>
            <strong>5.4</strong> A customer who wishes to cancel future renewal
            but keep the EcoTrack account or stored assessment history should
            contact the Provider for assistance before completing the
            account-deletion flow.
          </p>

          <p>
            <strong>5.5</strong> Refund eligibility is governed by the{" "}
            <Link className="terms-link" to="/refund-policy">
              Refund and Cancellation Policy
            </Link>
            . Unless mandatory law requires otherwise or a refund situation
            expressly identified in that Policy applies, paid fees are
            generally non-refundable once paid access has been provisioned.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">6</span>
            Licence and permitted use
          </h2>

          <p>
            <strong>6.1</strong> During the applicable subscription term,
            users receive a limited, non-exclusive, non-transferable and
            revocable right to access and use EcoTrack for their internal
            business or professional purposes in accordance with these Terms.
          </p>

          <p>
            <strong>6.2</strong> Users shall not:
          </p>

          <ul className="terms-list">
            <li>reverse engineer, decompile or attempt to derive source code;</li>
            <li>
              reproduce, resell, sublicense or commercially exploit EcoTrack
              beyond the permitted internal use;
            </li>
            <li>scrape or systematically extract platform content or outputs;</li>
            <li>introduce malicious, disruptive or harmful code;</li>
            <li>attempt unauthorised access to protected areas or data;</li>
            <li>use EcoTrack unlawfully, deceptively or fraudulently;</li>
            <li>allow unauthorised third-party access to an account.</li>
          </ul>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">7</span>
            Customer data
          </h2>

          <p>
            <strong>7.1</strong> Users remain responsible for information and
            data submitted to EcoTrack.
          </p>

          <p>
            <strong>7.2</strong> Users must ensure that submitted information
            is lawful, accurate and reasonably complete for the intended use of
            the service.
          </p>

          <p>
            <strong>7.3</strong> EcoTrack generates its outputs based solely on the information and questionnaire responses submitted by the user. The accuracy and usefulness of any scores, recommendations, reports or other outputs therefore depend on the accuracy, completeness and reliability of those responses.
          </p>

          <p>
            <strong>7.4</strong> Users must not submit special categories of
            personal data or unnecessary third-party personal information
            through EcoTrack.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">8</span>
            Service availability
          </h2>

          <p>
            <strong>8.1</strong> EcoTrack is provided on an &ldquo;as
            available&rdquo; basis.
          </p>

          <p>
            <strong>8.2</strong> Temporary interruption, delay or limited
            availability may occur due to maintenance, updates, security
            interventions, technical incidents, hosting or third-party service
            issues, payment-system issues or events outside the Provider&apos;s
            reasonable control.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">9</span>
            Intellectual property
          </h2>

          <p>
            <strong>9.1</strong> All intellectual property rights relating to
            EcoTrack, including its structure, methodology, interface, content,
            software logic and branding, remain the property of the Provider or
            its licensors, except where otherwise expressly stated.
          </p>

          <p>
            <strong>9.2</strong> Users retain ownership of data they submit to
            EcoTrack, subject to the rights necessary for the Provider to
            process that data in order to deliver and maintain the service.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">10</span>
            Outputs and limitations
          </h2>

          <p>
            <strong>10.1</strong> Scores, graphs, comparisons, benchmarking
            indicators, summaries, suggestions and downloadable outputs
            generated by EcoTrack are indicative only.
          </p>

          <p>
            <strong>10.2</strong> EcoTrack outputs do not constitute
            guarantees of ESG performance, financing eligibility, certification
            readiness, reporting completeness or regulatory compliance.
          </p>

          <p>
            <strong>10.3</strong> Users remain solely responsible for business,
            reporting, investment, operational or compliance decisions taken
            with reference to EcoTrack outputs.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">11</span>
            Limitation of liability
          </h2>

          <p>
            <strong>11.1</strong> To the maximum extent permitted by applicable
            law, EcoTrack is supplied on an &ldquo;as is&rdquo; and &ldquo;as
            available&rdquo; basis, without any guarantee that it will meet a
            user&apos;s specific commercial, reporting, certification or
            compliance objectives.
          </p>

          <p>
            <strong>11.2</strong> To the maximum extent permitted by applicable
            law, the Provider shall not be liable for indirect, consequential
            or incidental loss, loss of profit, loss of business opportunity,
            business interruption or losses resulting from decisions made on
            the basis of indicative EcoTrack outputs.
          </p>

          <p>
            <strong>11.3</strong> To the maximum extent permitted by applicable
            law, the Provider&apos;s aggregate liability relating to EcoTrack
            shall not exceed the amount paid by the relevant customer for
            EcoTrack during the twelve months preceding the event giving rise
            to the relevant claim. Nothing in these Terms excludes or limits
            liability for fraud, wilful misconduct, gross negligence or any
            other liability that cannot lawfully be excluded or limited.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">12</span>
            Data protection and technical providers
          </h2>

          <p>
            <strong>12.1</strong> Personal data are processed in accordance
            with the{" "}
            <Link className="terms-link" to="/privacy-policy">
              Privacy Policy
            </Link>{" "}
            and{" "}
            <Link className="terms-link" to="/cookie-policy">
              Cookie Policy
            </Link>
            .
          </p>

          <p>
            <strong>12.2</strong> Firebase / Google Cloud are used as part of
            EcoTrack account and technical infrastructure, and Stripe is used
            for connected payment checkout and payment handling.
          </p>

          <p>
            <strong>12.3</strong> EcoTrack is designed to assess business sustainability practices through questionnaire responses and is not intended for the submission of personal data relating to employees, suppliers, customers or other identifiable individuals. Users should not submit such personal data through the service.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">13</span>
            Suspension and termination
          </h2>

          <p>
            <strong>13.1</strong> Access to EcoTrack may be suspended or
            restricted where reasonably necessary for security, fraud
            prevention, payment default, legal compliance, investigation of
            suspected misuse or breach of these Terms.
          </p>

          <p>
            <strong>13.2</strong> Users may stop using EcoTrack at any time.
            Stopping use or submitting a support message does not itself cancel
            automatic renewal. Renewal must be cancelled through Stripe
            Customer Portal in accordance with clause 5, unless the Provider
            separately confirms cancellation.
          </p>

          <p>
            <strong>13.3</strong> Users may request account closure through the
            function available in Profile &amp; Settings. Where an active paid
            subscription exists, that flow first directs the user to Stripe
            Customer Portal to cancel renewal and, after cancellation is
            confirmed, submits an account-deletion request to the Provider.
          </p>

          <p>
            <strong>13.4</strong> Where cancellation takes effect at the end of
            the current paid period, access normally remains available until
            that date. Account deletion may therefore be completed after the
            paid period ends, subject to legally necessary record retention or
            a customer&apos;s specific request for earlier deletion and loss of
            remaining access.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">14</span>
            Governing law and jurisdiction
          </h2>

          <p>
            <strong>14.1</strong> These Terms are governed by the laws of
            Italy.
          </p>

          <p>
            <strong>14.2</strong> Any dispute arising in connection with
            EcoTrack shall be subject to the exclusive jurisdiction of the
            courts of Como, Italy, unless mandatory law requires otherwise.
          </p>

          <p>
            <strong>14.3</strong> Before commencing court proceedings, a
            customer may contact the Provider to seek an amicable resolution.
            No mandatory alternative dispute-resolution procedure is
            established by these Terms unless separately agreed or required by
            applicable law.
          </p>
        </section>

        <section className="terms-card">
          <h2>
            <span className="terms-number">15</span>
            Final provisions
          </h2>

          <p>
            <strong>15.1</strong> If any provision of these Terms is held to be
            invalid or unenforceable, the remaining provisions shall remain in
            force.
          </p>

          <p>
            <strong>15.2</strong> These Terms, together with the Privacy
            Policy, Cookie Policy, Refund and Cancellation Policy, Legal Notice
            and any applicable commercial agreement, constitute the contractual
            framework relating to EcoTrack.
          </p>

          <p>
            <strong>15.3</strong> The English version of these Terms prevails
            unless another language version is expressly designated as
            controlling.
          </p>

          <div className="terms-documents">
            <Link className="terms-document-link" to="/privacy-policy">
              Privacy Policy
            </Link>

            <Link className="terms-document-link" to="/cookie-policy">
              Cookie Policy
            </Link>

            <Link className="terms-document-link" to="/refund-policy">
              Refund and Cancellation Policy
            </Link>

            <Link className="terms-document-link" to="/legal-notice">
              Legal Notice
            </Link>
          </div>
        </section>

        <section className="terms-approval">
          <h2>Specific approval of contractual clauses</h2>

          <p>
            During checkout, business and professional users are required to
            specifically approve, pursuant to Articles 1341 and 1342 of the
            Italian Civil Code, the following clauses:
          </p>

          <p>
            <strong>
              Clause 4.2 concerning yearly automatic renewal; clauses 5.1 to
              5.5 concerning cancellation, account closure and refunds;
              clauses 8.1 and 8.2
              concerning service availability; clauses 11.1 to 11.3 concerning
              limitation of liability; clause 13.1 concerning suspension of
              access; and clause 14.2 concerning exclusive jurisdiction of the
              courts of Como.
            </strong>
          </p>
        </section>

        <section className="terms-contact">
          <h2>Contact</h2>

          <p>
            Questions concerning these Terms, refund requests, billing
            assistance or legal matters relating to EcoTrack may be sent to:
          </p>

          <a href="mailto:serap.cevirgen@viridisconsultancy.com">
            serap.cevirgen@viridisconsultancy.com
          </a>
        </section>

        <footer className="terms-footer">
          © 2026 Viridis by Serap Cevirgen · EcoTrack
        </footer>
      </main>
    </div>
  );
}
